// Imports
import { createSlice } from '@reduxjs/toolkit';
import { HubModel } from '../components/utils/Models';
import { SliceNames } from "../config/Constants";

// Slice state
interface HubSelectionSliceState {
  hubData: HubModel;
}

// Create slice
export const hubSelectionSlice = createSlice({
  name: SliceNames.HUB_SELECTION_DATA,
  initialState: {
    hubData: {} as HubModel
  },
  reducers: {
    setHubSelection(state: HubSelectionSliceState, action) {
      if (action.payload !== undefined) state.hubData = action.payload;
    }
  },
});

// Export state actions for this slice
export const { setHubSelection } = hubSelectionSlice.actions;

// Export state getters for this slice
export const getHubSelection = (state: any): HubModel => state[SliceNames.HUB_SELECTION_DATA].hubData;

// Export reducer
export const hubSelectionReducer = hubSelectionSlice.reducer;